import { render, staticRenderFns } from "./InsuranceManagement.vue?vue&type=template&id=44b5b9c6&scoped=true"
import script from "./InsuranceManagement.vue?vue&type=script&lang=js"
export * from "./InsuranceManagement.vue?vue&type=script&lang=js"
import style0 from "./InsuranceManagement.vue?vue&type=style&index=0&id=44b5b9c6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b5b9c6",
  null
  
)

export default component.exports